var $da9b443e89eebc6b$exports = {};
$da9b443e89eebc6b$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Sz\xEDnv\xE1laszt\xF3",
  "colorSwatch": "sz\xEDnt\xE1r",
  "transparent": "\xE1tl\xE1tsz\xF3",
  "twoDimensionalSlider": "2D-cs\xFAszka"
};
export { $da9b443e89eebc6b$exports as default };